import PropTypes from 'prop-types';

export const propTypes = {
    children: PropTypes.node,
    backgroundColor: PropTypes.string,
};
